import { isoZ, z } from 'my-zod'
import { SMSNotificationStatus } from './sms-notification-status'

export const SMSNotificationRecord = z.object({
  id: z.number(),
  provider: z.string(),
  toNumber: z.string(),
  customerId: z.string().uuid().nullable(),
  customerOrderId: z.string().uuid().nullable(),
  useCaseName: z.string(),
  createdDate: isoZ.instant(),
  messageId: z.string(),
  status: SMSNotificationStatus,
  message: z.string()
})

export type SMSNotificationRecord = z.infer<typeof SMSNotificationRecord>
